// Karishye attribution — added by Karishye OS console, 29 Aug 2026.
// Remembers which ad/source brought a visitor (utm tags + click ids), keeps it
// 90 days in a first-party cookie, attaches it to the cart (arrives on orders
// as note attributes), and tags WhatsApp links with a short (ref:...) origin.
// No personal data read or sent anywhere outside this store. Safe to delete.

(function () {
  try {
    var KEYS = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid','wbraid','gbraid','ttclid'];
    var COOKIE = 'k_attrib';

    function readCookie() {
      var m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
      if (!m) return null;
      try { return JSON.parse(decodeURIComponent(m[1])); } catch (e) { return null; }
    }
    function writeCookie(obj) {
      var v = encodeURIComponent(JSON.stringify(obj));
      document.cookie = COOKIE + '=' + v + '; path=/; max-age=' + (90*24*3600) + '; SameSite=Lax';
    }

    // 1. capture tags from the current URL (first touch wins; new ad click refreshes)
    var params = new URLSearchParams(location.search);
    var fresh = {};
    KEYS.forEach(function (k) { var v = params.get(k); if (v) fresh[k] = v.slice(0, 120); });
    var saved = readCookie() || {};
    var hasFresh = Object.keys(fresh).length > 0;
    var attrib = hasFresh ? fresh : saved;
    if (hasFresh) { fresh._t = new Date().toISOString().slice(0, 10); writeCookie(fresh); }
    if (!Object.keys(attrib).length) return;

    // 2. attach to the cart (arrives on the order as note attributes)
    function syncCart() {
      var attrs = {};
      KEYS.forEach(function (k) { if (attrib[k]) attrs[k] = attrib[k]; });
      if (!Object.keys(attrs).length) return;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {});
    }
    // sync once per session, and again when something is added to the cart
    if (!sessionStorage.getItem('k_attrib_synced')) {
      syncCart();
      try { sessionStorage.setItem('k_attrib_synced', '1'); } catch (e) {}
    }
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.action && f.action.indexOf('/cart/add') !== -1) setTimeout(syncCart, 1500);
    }, true);

    // 3. tag WhatsApp links with a short origin ref (console reads it back)
    var ref = attrib.utm_campaign || (attrib.gclid || attrib.wbraid || attrib.gbraid ? 'google-click' : '') || (attrib.fbclid ? 'meta-click' : '') || attrib.utm_source || '';
    if (ref) {
      ref = String(ref).replace(/[^\w-]/g, '').slice(0, 40);
      var tagLinks = function () {
        var links = document.querySelectorAll('a[href*="wa.me"], a[href*="api.whatsapp.com"]');
        for (var i = 0; i < links.length; i++) {
          var a = links[i];
          if (a.dataset.kAttrib) continue;
          a.dataset.kAttrib = '1';
          try {
            var u = new URL(a.href);
            var t = u.searchParams.get('text') || '';
            if (t.indexOf('ref:') === -1) {
              u.searchParams.set('text', (t ? t + ' ' : '') + '(ref:' + ref + ')');
              a.href = u.toString();
            }
          } catch (e) {}
        }
      };
      tagLinks();
      new MutationObserver(tagLinks).observe(document.documentElement, { childList: true, subtree: true });
    }
  } catch (e) { /* never break the store */ }
})();
